import React from 'react';
import PropTypes from 'prop-types';
import filesize from 'filesize';

import constants from '../../../../qti/Constants';
import stringUtils from '../../../../qti/utils/StringUtils';
import UploadButton from './UploadButton';

import styles from './uploadInteraction.scss';

const examContext = constants.componentContexts.EXAM;

class UploadViewInitial extends React.Component {
    static propTypes = {
        context: PropTypes.string.isRequired,
        handleFileSelection: PropTypes.func.isRequired,
        isReadOnly: PropTypes.bool,
        model: PropTypes.object.isRequired,
        services: PropTypes.object.isRequired,
    };

    componentDidMount() {
        if (this.promptRef) {
            this.promptRef.focus();
        }
    }

    render() {
        const { getFileUploadMaxSize, shouldShowPrompt } = this.props.services.interactionService;
        const maxFileSize = getFileUploadMaxSize();
        const maxFileSizeFormatted = filesize(maxFileSize);
        const { context, isReadOnly, model, services } = this.props;
        const { t } = services.translationService;
        const { prompt, supportedFileExtensions } = model;
        const id = stringUtils.getUID();
        const fileTypesText = supportedFileExtensions === '*'
            ? t('interactions.upload.allFileTypesAllowed')
            : `${t('interactions.upload.allowedFileExtensionsText')} 
               <strong class="fileExtensionsList">${supportedFileExtensions}</strong>`;

        const fileSizeText = t('interactions.upload.maximumFileSizeText', { maximumFileSize: maxFileSizeFormatted });
        const showPrompt = shouldShowPrompt(prompt);
        const infoText = `<div class="infoText">${fileTypesText} ${fileSizeText}</div>`;

        return (
            <div className={styles.initialView}>
                <div className={styles.centeredText}>
                    <i className={`${styles.statusIcon} fa fa-upload`} aria-hidden="true" /><br />
                    { showPrompt &&
                        <label
                            className="interaction-prompt"
                            htmlFor={id}
                            ref={(element) => { this.promptRef = element; }}
                            tabIndex="-1"
                            dangerouslySetInnerHTML={{ __html: prompt.content }}
                        />
                    }

                    <div
                        className={styles.centeredText}
                        dangerouslySetInnerHTML={{ __html: infoText }}
                    />

                    <UploadButton
                        disabled={isReadOnly || context !== examContext}
                        isFocused={!showPrompt}
                        handleFileSelection={this.props.handleFileSelection}
                        id={id}
                        supportedFileExtensions={supportedFileExtensions}
                        text={t('interactions.upload.btnSelectFileToUpload')}
                    />
                </div>
            </div>
        );
    }
}

export default UploadViewInitial;
